import {GetOdontoSpecialties} from 'domain/usecases';
import {RemoteGetOdontoSpecialties} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetOdontoSpecialties = (): GetOdontoSpecialties =>
	new RemoteGetOdontoSpecialties(
		makeBFFApiUrl(BookingFlowEndPoints.odontoSpecialties),
		makeAuthorizeHttpClientDecorator(),
	);
